import { render, staticRenderFns } from "./AddMeetingButton.vue?vue&type=template&id=28b56be5&scoped=true&"
import script from "./AddMeetingButton.vue?vue&type=script&lang=js&"
export * from "./AddMeetingButton.vue?vue&type=script&lang=js&"
import style0 from "./AddMeetingButton.vue?vue&type=style&index=0&id=28b56be5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b56be5",
  null
  
)

export default component.exports